import request from '@/utils/request'

export function getLoginResult(data) {
    return request({
        url: '/wechat/getLoginResult',
        method: 'get',
        params: data
    })
}

// 获取扫码登录用的小程序码（base64）
export function getMiniLoginQrCode(data) {
    return request({
        url: '/wechat/miniLoginQrCode',
        method: 'get',
        params: data
    })
}
